import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Collapse, Navbar, NavbarToggler, Nav } from 'reactstrap'
import CreateMenu from '../CreateMenu/CreateMenu'
import AdminMenu from '../AdminMenu/AdminMenu'
import WorkspaceMenu from '../WorkspaceMenu/WorkspaceMenu'
import UserMenu from '../UserMenu/UserMenu'
import SchemaMenu from '../SchemaMenu/SchemaMenu'
import { ATTRIBUTE_NAME } from '../../constants'
import { hasSidebar, getAttributeValue, configValue } from '../../utils'
import HomeButton from './HomeButton'
import SidebarButton from './SidebarButton'
import { gql } from '@apollo/client'
import { SESSION_INFO_QUERY } from '../../graphql.js'
import './PageTop.css'
import UpdateClientButton from './UpdateClientButton'
import ClientVersion from './ClientVersion'

const SESSION_INFO = gql(SESSION_INFO_QUERY)

export default function PageTop() {
  const location = useLocation()
  console.log('PageTop rendered')

  const [isOpen, toggle] = useState(false)
  const [updateRequired, setUpdateRequired] = useState(false)
  const [versions, setVersions] = useState()
  const [hasAdmin, setHasAdmin] = useState(false)
  const [showWorkspaceMenu, setShowWorkspaceMenu] = useState(false)
  const [showUserMenu, setShowUserMenu] = useState(false)

  // create menu visibility is controlled by a user preference (default is not visible)
  const createMenu = getAttributeValue(ATTRIBUTE_NAME.showCreateMenu) === 'N' ? '' : <CreateMenu />

  // set the browser tab title
  useEffect(() => {
    document.title = `CE2 - ${configValue('title')}`
  })

  useEffect(() => {
    async function executeQuery() {
      const { data } = await window.apolloClient.query({ query: SESSION_INFO })
      console.log('PageTop.useEffect: ', data)
      if (data.sessionInfo) {
        setHasAdmin(data.sessionInfo.hasAdmin)
        setShowWorkspaceMenu(data.sessionInfo.showWorkspaceMenu)
        setShowUserMenu(data.sessionInfo.showUserMenu)
        const serverClientVersion = data.sessionInfo.clientVersion
        const localClientVersion = configValue('CLIENT VERSION')
        console.log(`PageTop: LOCAL client version: ${localClientVersion}, SERVER client version: ${serverClientVersion}`)
        if (localClientVersion !== serverClientVersion && !updateRequired) {
          setUpdateRequired(true)
          setVersions({ oldVersion: localClientVersion, newVersion: serverClientVersion })
        }
      } 
    }
    executeQuery()
  })

  // for pages with no PageTop
  const params = new URLSearchParams(location.search)
  if (params.get('noPageTop')) {
    return ''
  }

  // make room for the sidebar
  if (hasSidebar()) {
    document.body.classList.add('side-bar-padding')
  }

  let updateButton = ''
  if (updateRequired) {
    updateButton = <UpdateClientButton versions={versions} />
  }

  let schemaMenu = ''
  let adminMenu = ''
  if (hasAdmin) {
    adminMenu = <AdminMenu />
    schemaMenu = <SchemaMenu />
  }

  let workspaceMenu = ''
  if (showWorkspaceMenu) {
    workspaceMenu = <WorkspaceMenu />
  }

  let userMenu = ''
  if (showUserMenu) {
    userMenu = <UserMenu />
  }

  return (
    <Navbar light expand="md" fixed="top">
      <div style={{ height: '51px', minWidth: '105px', padding: '8px 8px 8px 0px' }} >
        <ClientVersion />
        <HomeButton />
        <SidebarButton />
        {updateButton}
      </div>
      <NavbarToggler onClick={() => { toggle(!isOpen) }} />
      <Collapse isOpen={isOpen} navbar>
        <Nav navbar pills>
          {createMenu}
          {adminMenu}
          {workspaceMenu}
        </Nav>
        <Nav className="ml-auto" navbar pills style={{ marginLeft: 'auto'}}>
          {schemaMenu}
          {userMenu}
        </Nav>
      </Collapse>
    </Navbar>
  )
}
